import { Component, Input, OnInit, OnChanges, OnDestroy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DocumentosObservableService } from './DocumentosObservable';
import { isNullOrUndefined } from '../objectUtils';
import { Observable, Subscription } from 'rxjs';
//import DateHelpers from '../DateHelpers';

interface Documento {
  name: string,
  count: number
}

interface DocumentsPerson {
  namePerson: string,
  count:number,
  documents: Documento[]

}


@Component({
  selector: 'documents-needed',
  templateUrl: './documents-needed.component.html',
  styleUrls: ['./documents-needed.component.scss'],
  standalone:false
})

export class DocumentsNeededComponent implements OnInit, OnDestroy {

  public documentsPerPerson: DocumentsPerson[] = [];
  public expandedView: boolean = false;
  private mainSubscription: Subscription = new Subscription();
  constructor(private documentsObservableService: DocumentosObservableService) { }

  ngOnInit(): void {
    this.mainSubscription.add(
      this.documentsObservableService.notifications.subscribe(
        (result: models.DocumentosObservableVM[]) => {
          if (result !== null) {
          this.documentsPerPerson = [];
          const pessoas = result.forEach(doc => {
            const findPessoa = this.documentsPerPerson.filter(dp => dp.namePerson === doc.ownerName).length > 0;
            if (!findPessoa) {
              this.documentsPerPerson.push({
                namePerson: doc.ownerName,
                count: result.filter(ct => ct.ownerName === doc.ownerName).length,
                documents: result
                  .filter(ct => ct.ownerName === doc.ownerName)
                  .map(mp => { return { name: mp.documentTipologyDescription, count: 0 } })

              })
            }
          });
          }
        }
      )

    );

    this.mainSubscription.add(
      this.documentsObservableService.toDeleteAll.subscribe(
        (result: models.DocumentosObservableVM[]) => {
          if (result != null) {
            this.documentsPerPerson = [];
          }
       
         

        }
      )

    );
  }

  ngOnDestroy(): void {
    this.mainSubscription.unsubscribe();
  }

}
